import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";
import WGRTable from "./pohTable";


//import WGRTotals from "./iohTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
   const totals = useMemo(() => {
    return rows.reduce(
      (total, row) => ({
        noofcoaches:
          total.noofcoaches +
          Number(row.noofcoaches || 0),

        Mech_LabourCost:
          total.Mech_LabourCost +
          Number(row.Mech_LabourCost || 0),

           Mech_MaterialCost:
          total.Mech_MaterialCost +
          Number(row.Mech_MaterialCost || 0),

        Elec_LabourCost:
          total.Elec_LabourCost +
          Number(row.Elec_LabourCost || 0),

      Elec_MaterialCost:
          total.Elec_MaterialCost +
          Number(row.Elec_MaterialCost || 0),
          
        totalcost:
          total.totalcost +
          Number(row.totalcost || 0),

         }),

        
          

      {
        noofcoaches: 0,
        Mech_LabourCost: 0,
        Mech_MaterialCost: 0,
        Elec_LabourCost: 0,
        Elec_MaterialCost: 0,
      
        totalcost: 0,
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt:5,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
        >
          Railway  : {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

     

      {/* Shop Total */}
 {/* THIS IS WHERE WGRTable SHOULD BE */}
   <WGRTable
  rows={rows}
  shop={shop}
  totals={totals}
  showTotal={true}
/>
      
        
    </Paper>
  );
}

